function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { ReplaceAroundStep, ReplaceStep } from '@atlaskit/editor-prosemirror/transform';
import { findParentNodeOfTypeClosestToPos } from '@atlaskit/editor-prosemirror/utils';
export var trackSyncBlocks = function trackSyncBlocks(predicate, tr, state) {
  var removed = {};
  var added = {};
  if (!tr.docChanged) {
    return {
      removed: [],
      added: []
    };
  }

  // and cast to specific step types
  var replaceSteps = tr.steps.filter(function (step) {
    return step instanceof ReplaceStep || step instanceof ReplaceAroundStep;
  });

  // this is a quick check to see if any insertion/deletion of bodiedSyncBlock happened
  var hasBodiedSyncBlockChanges = replaceSteps.some(function (step) {
    var from = step.from,
      to = step.to;
    var hasChange = false;
    if (from !== to) {
      step.getMap().forEach(function (oldStart, oldEnd) {
        if (oldStart !== oldEnd && !hasChange) {
          var deletedSlice = state.doc.slice(Math.max(0, oldStart), Math.min(state.doc.content.size, oldEnd));
          deletedSlice.content.forEach(function (node, _, index) {
            if (hasChange) {
              return;
            }
            // for top level nodes
            if (predicate(node)) {
              hasChange = true;
            }
          });
        }
      });
    }

    // no need to check insertions if we already found deletions
    if (step.slice.content.size > 0 && !hasChange) {
      step.slice.content.forEach(function (node) {
        if (predicate(node) && !hasChange) {
          hasChange = true;
        }
      });
    }
    return hasChange;
  });
  if (hasBodiedSyncBlockChanges) {
    var oldDoc = state.doc;
    var newDoc = tr.doc;
    var syncBlockMapOld = {};
    var syncBlockMapNew = {};
    oldDoc.content.forEach(function (node) {
      if (predicate(node)) {
        var syncBlockAttr = node.attrs;
        syncBlockMapOld[syncBlockAttr.localId] = syncBlockAttr;
      }
    });
    newDoc.content.forEach(function (node) {
      if (predicate(node)) {
        var syncBlockAttr = node.attrs;
        syncBlockMapNew[syncBlockAttr.localId] = syncBlockAttr;
      }
    });

    // Find removed sync blocks
    for (var localId in syncBlockMapOld) {
      if (!syncBlockMapNew[localId]) {
        removed[localId] = syncBlockMapOld[localId];
      }
    }

    // Find added sync blocks
    for (var _localId in syncBlockMapNew) {
      if (!syncBlockMapOld[_localId]) {
        added[_localId] = syncBlockMapNew[_localId];
      }
    }
  }
  return {
    removed: Object.values(removed),
    added: Object.values(added)
  };
};

/**
 *
 * @returns true if steps modifies children node within bodiedSyncBlock
 */
export var hasEditInSyncBlock = function hasEditInSyncBlock(tr, state) {
  var bodiedSyncBlock = state.schema.nodes.bodiedSyncBlock;
  var _iterator = _createForOfIteratorHelper(tr.steps),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var step = _step.value;
      var map = step.getMap();
      var doc = tr.doc;
      var positions = [];

      // Extract positions from steps dynamically based on applicable properties
      if ('from' in step && typeof step.from === 'number' && 'to' in step && typeof step.to === 'number') {
        var _ref = step,
          from = _ref.from,
          to = _ref.to;
        positions.push(from, to);
      } else if ('pos' in step && typeof step.pos === 'number') {
        var _ref2 = step,
          pos = _ref2.pos;
        positions.push(pos);
      }
      for (var _i = 0, _positions = positions; _i < _positions.length; _i++) {
        var _pos = _positions[_i];
        var newPos = map.map(_pos);
        if (newPos >= 0 && newPos <= doc.content.size) {
          if (findParentNodeOfTypeClosestToPos(doc.resolve(newPos), bodiedSyncBlock)) {
            return true;
          }
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return false;
};